// extracted by mini-css-extract-plugin
module.exports = {"defect":"ImageDefectIndicator_defect__2D81U"};